
import { Vue, Component } from 'vue-property-decorator';
import { warkLabel } from '@/models/wark';

@Component({})
export default class PromoteDailyData extends Vue {
  refresh() {
    // console.log('refresh');
  }

  back() {
    this.$router.back();
  }

  columns = warkLabel.init('PromoteDailyData');
  data = [];
}
